/* eslint-disable complexity */
import React, { useEffect, useState } from 'react'
import SubFilters from './SubFilters'
import GetmoviesAppInfoData from '../Services/Queries/GetmoviesAppInfoConfigService'
import { AboutEnTe } from '../Components/Data/StaticData'
import FiltersUIsub from './FiltersUIsub'
function FiltersUI(props) {
  const [appInfoServiceData, setAppInfoServiceData] = useState()
  const {
    ToRatingvalue,
    showDates,
    sortOrderReset,
    filterDisableWithoutSelect,
    statusType,
    isLoading,
    checkTrue,
    disapperAllFilters,
    selectedGenres,
    changeCategoryAge,
    agevalue,
    changeCategoryGenre,
    ageRestrictionClear,
    selectedOTT,
    changeCategoryOTT,
    Ratingvalue,
    changeCategoryRating,
    changeOthers,
    selectedOthers,
    checkposterlink,
    checkPosterurl,
    changeAbout,
    selectedAbout,
    statemovieDirectedBy,
    movieDirectedBy,
    checkmovieProducedBy,
    checkproducer,
    changeSortOrderBy,
    sortByorder,
    CheckBoxClick,
    handlePepularMovie,
    resethandle,
    searchValue,
    getMoviesFilterData,
    setfilterDisableWithoutSelect,
    handleGOAT,
    handleoriginalLanguage,
    originalLanguageTelugu,
    GOAT,
    movieFilterBy,
  } = props
  const validation = {
    main: { color: 'red', fontSize: '12px' },
    mainBlack: { color: 'black', fontSize: '12px' },
  }

  setfilterDisableWithoutSelect(
    checkposterlink ||
      showDates ||
      selectedGenres.length > 0 ||
      Ratingvalue.length > 0 ||
      checkTrue ||
      selectedOTT.length > 0 ||
      searchValue.length > 0 ||
      agevalue !== '' ||
      sortByorder !== '' ||
      props.sortBy !== '' ||
      statemovieDirectedBy ||
      checkproducer ||
      selectedAbout.length > 0 ||
      selectedOthers.length > 0 ||
      props.SearchPersonProd.length > 0 ||
      props.SearchPerson.length > 0 ||
      props.SearchPersonDialog.length > 0 ||
      props.SearchPersonMusic.length > 0 ||
      props.SearchPersonCenimato.length > 0 ||
      props.SearchPersonEditor.length > 0 ||
      props.SearchPersonCast.length > 0,
  )

  useEffect(() => {
    const GetmoviesAppInfo = async () => {
      const appInfoData = await GetmoviesAppInfoData()
      setAppInfoServiceData(appInfoData && appInfoData.getMoviesAppInfoConfig)
    }

    GetmoviesAppInfo()
  }, [])
  // console.log(appInfoServiceData && appInfoServiceData, 'appInfoServiceData.ottListFilters')

  //
  return (
    <div>
      {isLoading ? (
        <div className='loading-overlay'>
          <span className='fas fa-spinner fa-3x fa-spin'></span>
        </div>
      ) : (
        ''
      )}
      {disapperAllFilters ? (
        <FiltersUIsub
          statusType={statusType}
          appInfoServiceData={appInfoServiceData}
          selectedGenres={selectedGenres}
          changeCategoryGenre={changeCategoryGenre}
          selectedOTT={selectedOTT}
          changeCategoryOTT={changeCategoryOTT}
          selectedOthers={selectedOthers}
          CheckBoxClick={CheckBoxClick}
          changeOthers={changeOthers}
          changeCategoryAge={changeCategoryAge}
          agevalue={agevalue}
          ageRestrictionClear={ageRestrictionClear}
          AboutEnTe={AboutEnTe}
          selectedAbout={selectedAbout}
          changeAbout={changeAbout}
          Ratingvalue={Ratingvalue}
          sortByorder={sortByorder}
          sortOrderReset={sortOrderReset}
          changeSortOrderBy={changeSortOrderBy}
          changeCategoryRating={changeCategoryRating}
          ToRatingvalue={ToRatingvalue}
          validation={validation}
          checkPosterurl={checkPosterurl}
          checkposterlink={checkposterlink}
          checkmovieProducedBy={checkmovieProducedBy}
          checkproducer={checkproducer}
          movieDirectedBy={movieDirectedBy}
          statemovieDirectedBy={statemovieDirectedBy}
          checkTrue={checkTrue}
          handlePepularMovie={handlePepularMovie}
          handleGOAT={handleGOAT}
          handleoriginalLanguage={handleoriginalLanguage}
          originalLanguageTelugu={originalLanguageTelugu}
          GOAT={GOAT}
          handleFilterChange={props.handleFilterChange}
          movieFilterBy={movieFilterBy}
          {...props}
        />
      ) : (
        ''
      )}
      <SubFilters
        filterDisableWithoutSelect={filterDisableWithoutSelect}
        // statusType={statusType}
        getMoviesFilterData={getMoviesFilterData}
        resethandle={resethandle}
      />
    </div>
  )
}

export default FiltersUI
